/* Keep the homepage hero's CTA clear; reuse the PDP shortcut after the hero. */
(() => {
  let observer;
  function connect() {
    observer?.disconnect();
    const hero = document.querySelector('.bl-home-hero');
    if (!hero) return;
    observer = new IntersectionObserver(([entry]) => {
      document.body.classList.toggle('bl-home-past-hero', entry.boundingClientRect.bottom <= 0);
    }, { threshold: 0 });
    observer.observe(hero);
  }
  connect();
  document.addEventListener('shopify:section:load', connect);
})();
